"use strict";
/**
 *  tracingMonitoringModule
 *
 * Description 策划中心 实时线索 计划性线索 监测跟踪
 * Author Qian.qianchen 2019-06-18
 */
angular.module('tracingMonitoringModule', ['docDetailModule', 'picDetailModule', 'tracingMonitoringRouterModule', 'tracingMonitoringLeftModule', 'tracingMonitoringServiceModule', 'trackLeftToolsModule', 'pictureSliderModule', 'rollMonitorModule', 'trsPreviewTitleDocModule'])
    .controller('tracingMonitoringCtrl', ["$scope", "$state", "trsHttpService", "trsspliceString", "$q", "$filter", "$anchorScroll", "$location", "$element", "$timeout",
        function($scope, $state, trsHttpService, trsspliceString, $q, $filter, $anchorScroll, $location, $element, $timeout) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    tabList: [{ name: '相关热点', value: 'relatedHot' },
                        { name: '相关政策', value: 'relatedPolicy' },
                        { name: '相关报道', value: 'relatedReport' },
                        { name: '数据统计', value: 'dataStatistics' },
                        { name: '关键词云', value: 'keywordCloud' },
                        { name: '关联稿件', value: 'relatedArticles' },
                        { name: '关联图片', value: 'relatedPictures' }
                    ],
                    trackId: $state.params.trackid,
                    trackName: $state.params.trackname,
                    channelList: { 'wz': { name: '网站', color: '#FFBE5C' }, 'wb': { name: '微博', color: '#FE4A4A' }, 'wx': { name: '微信', color: '#6AD861' }, 'app': { name: '客户端', color: '#d64541' }, 'szb': { name: '数字报', color: '#F76280' }, },
                    showChannel: { 'wz': true, 'wb': true, 'wx': true, 'app': true, 'szb': true },
                    checkRollFlag: true,
                    checkClickFlag: true,
                }
                $scope.data = {
                    relatedHot: []
                }
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                $scope.status.selectedTab = $scope.status.tabList[0];
                // 相关热点
                getRelatedHot();
                // 相关政策
                getRelatedPolicy();
                // 相关报道-内部报道
                getReport(1).then((result) => {
                    $scope.data.insideReport = result.PAGEITEMS;
                });
                // 相关报道-一级媒体报道
                getReport(2).then((result) => {
                    $scope.data.firstReport = result.PAGEITEMS;
                });
                // 数据统计-内部报道
                getAreaCount().then(() => {
                    if ($scope.data.areaCount.length > 0) {
                        initMapCanvas();
                    }
                });
                // 数据统计-数据统计
                getChannelsData().then(() => {
                    if ($scope.data.channelsData.length > 0) {
                        initBarCanvas();
                    }
                });
                // 关键词云-关键词
                getKeywordsData().then(() => {
                    if ($scope.data.keywordsData.length > 0) {
                        initKeywordsCloud();
                    }
                });
                // 关键词云-情感词
                getEmotionWordsData().then(() => {
                    if ($scope.data.emotionWordsData.length > 0) {
                        initEmotionWordsCloud();
                    }
                });
                // 关联稿件
                getRelatedArticles();
            }
            /**
             * [getRelatedHot description] 获取相关热点数据
             * @return {[type]} [description]
             */
            function getRelatedHot() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackHot',
                    id: $scope.status.trackId,
                    page_no: 0,
                    page_size: 5,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.relatedHot = data == '' ? [] : data.PAGEITEMS;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [getRelatedPolicy description] 获取相关政策数据
             * @return {[type]} [description]
             */
            function getRelatedPolicy() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackPolicy',
                    id: $scope.status.trackId,
                    page_no: 0,
                    page_size: 5,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.relatedPolicy = data.PAGEITEMS;
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [getReport description] 获取相关报道
             * @param  {[type]} type [description] 类型（1:内部报道 2:一级媒体报道）
             * @return {[type]}      [description]
             */
            function getReport(type) {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackReport',
                    id: $scope.status.trackId,
                    page_no: 0,
                    page_size: 5,
                    type: type
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [getAreaCount description] 获取地域数据（数据统计-内部报道）
             * @return {[type]} [description]
             */
            function getAreaCount() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackAreaCount',
                    id: $scope.status.trackId,
                    page_no: 0,
                    page_size: 99,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.areaCount = data;
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [initMapCanvas description] 地图图表初始化
             * @return {[type]} [description]
             */
            function initMapCanvas() {
                require(['echarts'], function(echarts) {
                    let mapDom = document.getElementById("map_canvas");
                    if (!mapDom) {
                        return;
                    }
                    $scope.data.mapChart = echarts.init(mapDom);
                    let option = {
                        title: {
                            text: "",
                        },
                        geo: {
                            roam: false,
                            silent: false, // 沉默模式，禁止所有的点击和鼠标事件
                            map: 'china',
                            label: {
                                normal: {
                                    show: false,
                                    // formatter: '{a}:{b}: {c}'
                                },
                            },
                            itemStyle: {
                                borderColor: "#FFFFFF"
                            },
                        },
                        visualMap: { // 色值渐变条
                            type: 'continuous',
                            text: ['高', '低'],
                            showLabel: true,
                            seriesIndex: [0],
                            min: $scope.data.areaCount[$scope.data.areaCount.length - 1].num,
                            max: $scope.data.areaCount[0].num,
                            inRange: {
                                color: ['#F4F5F4', '#69A5D3']
                            },
                            textStyle: {
                                color: '#2F2F2F'
                            },
                            bottom: 30,
                            left: 'left',
                            orient: 'horizontal',
                            calculable: true,
                        },
                        series: [{
                            name: '',
                            type: 'map',
                            roam: false,
                            geoIndex: 0,
                            data: $scope.data.areaCount.map((_item) => {
                                return {
                                    name: _item.name,
                                    value: _item.num
                                }
                            })
                        }]
                    };
                    trsHttpService.httpServer("./planningCenter/realTimeClues/plannedClues/tracingMonitoring/data/china.json", "", "get").then(function(data) {
                        echarts.registerMap('china', data);
                        $scope.data.mapChart.setOption(option);
                    });
                });
            }

            /**
             * [getChannelsData description] 获取数据统计数据
             * @return {[type]} [description]
             */
            function getChannelsData() {
                let defer = $q.defer();
                let dateStr = '';
                if ($scope.data.fromdate && $scope.data.untildate) {
                    dateStr = $scope.data.fromdate + ';' + $scope.data.untildate;
                }
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackDateCount',
                    id: $scope.status.trackId,
                    search_date: dateStr
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.channelsData = data == '' ? [] : data;
                    //$scope.data.channelsData = [{ "data": [{ "date": "2019/05/01", "num": 20 }, { "date": "2019/05/02", "num": 15 }, { "date": "2019/05/03", "num": 21 }, { "date": "2019/05/04", "num": 42 }, { "date": "2019/05/05", "num": 48 }, { "date": "2019/05/06", "num": 16 }, { "date": "2019/05/07", "num": 12 }, { "date": "2019/05/08", "num": 32 }, { "date": "2019/05/09", "num": 22 }, { "date": "2019/05/10", "num": 43 }, { "date": "2019/05/11", "num": 7 }, { "date": "2019/05/12", "num": 36 }, { "date": "2019/05/13", "num": 35 }, { "date": "2019/05/14", "num": 58 }, { "date": "2019/05/15", "num": 156 }, { "date": "2019/05/16", "num": 100 }, { "date": "2019/05/17", "num": 93 }, { "date": "2019/05/18", "num": 59 }, { "date": "2019/05/19", "num": 59 }, { "date": "2019/05/20", "num": 50 }, { "date": "2019/05/21", "num": 67 }, { "date": "2019/05/22", "num": 41 }, { "date": "2019/05/23", "num": 69 }, { "date": "2019/05/24", "num": 106 }, { "date": "2019/05/25", "num": 82 }, { "date": "2019/05/26", "num": 67 }, { "date": "2019/05/27", "num": 43 }, { "date": "2019/05/28", "num": 64 }, { "date": "2019/05/29", "num": 76 }, { "date": "2019/05/30", "num": 81 }, { "date": "2019/05/31", "num": 26 }, { "date": "2019/06/01", "num": 94 }, { "date": "2019/06/02", "num": 65 }, { "date": "2019/06/03", "num": 39 }, { "date": "2019/06/04", "num": 96 }, { "date": "2019/06/05", "num": 133 }, { "date": "2019/06/06", "num": 80 }, { "date": "2019/06/07", "num": 57 }, { "date": "2019/06/08", "num": 34 }, { "date": "2019/06/09", "num": 50 }, { "date": "2019/06/10", "num": 84 }, { "date": "2019/06/11", "num": 95 }, { "date": "2019/06/12", "num": 164 }, { "date": "2019/06/13", "num": 214 }, { "date": "2019/06/14", "num": 91 }, { "date": "2019/06/15", "num": 147 }, { "date": "2019/06/16", "num": 1041 }, { "date": "2019/06/17", "num": 844 }, { "date": "2019/06/18", "num": 431 }, { "date": "2019/06/19", "num": 325 }, { "date": "2019/06/20", "num": 285 }, { "date": "2019/06/21", "num": 232 }, { "date": "2019/06/22", "num": 222 }, { "date": "2019/06/23", "num": 192 }, { "date": "2019/06/24", "num": 170 }, { "date": "2019/06/25", "num": 166 }], "channel": "wz" }, { "data": [{ "date": "2019/05/04", "num": 1 }, { "date": "2019/05/12", "num": 1 }, { "date": "2019/06/06", "num": 1 }, { "date": "2019/06/10", "num": 2 }, { "date": "2019/06/11", "num": 2 }, { "date": "2019/06/14", "num": 1 }, { "date": "2019/06/15", "num": 1 }, { "date": "2019/06/16", "num": 30 }, { "date": "2019/06/17", "num": 10 }, { "date": "2019/06/18", "num": 4 }, { "date": "2019/06/19", "num": 2 }, { "date": "2019/06/21", "num": 2 }, { "date": "2019/06/23", "num": 2 }, { "date": "2019/06/24", "num": 1 }, { "date": "2019/06/25", "num": 2 }], "channel": "wb" }, { "data": [{ "date": "2019/05/01", "num": 1 }, { "date": "2019/05/02", "num": 1 }, { "date": "2019/05/03", "num": 1 }, { "date": "2019/05/12", "num": 1 }, { "date": "2019/05/15", "num": 2 }, { "date": "2019/05/16", "num": 2 }, { "date": "2019/05/17", "num": 2 }, { "date": "2019/05/21", "num": 3 }, { "date": "2019/05/22", "num": 1 }, { "date": "2019/05/23", "num": 1 }, { "date": "2019/05/24", "num": 2 }, { "date": "2019/05/26", "num": 1 }, { "date": "2019/05/29", "num": 2 }, { "date": "2019/05/30", "num": 3 }, { "date": "2019/05/31", "num": 2 }, { "date": "2019/06/01", "num": 3 }, { "date": "2019/06/04", "num": 1 }, { "date": "2019/06/05", "num": 3 }, { "date": "2019/06/09", "num": 1 }, { "date": "2019/06/12", "num": 4 }, { "date": "2019/06/13", "num": 5 }, { "date": "2019/06/15", "num": 2 }, { "date": "2019/06/16", "num": 18 }, { "date": "2019/06/17", "num": 16 }, { "date": "2019/06/18", "num": 6 }, { "date": "2019/06/19", "num": 3 }, { "date": "2019/06/20", "num": 4 }, { "date": "2019/06/21", "num": 6 }, { "date": "2019/06/22", "num": 3 }, { "date": "2019/06/23", "num": 5 }, { "date": "2019/06/25", "num": 1 }], "channel": "wx" }, { "data": [{ "date": "2019/05/01", "num": 39 }, { "date": "2019/05/02", "num": 7 }, { "date": "2019/05/03", "num": 7 }, { "date": "2019/05/04", "num": 43 }, { "date": "2019/05/05", "num": 47 }, { "date": "2019/05/06", "num": 14 }, { "date": "2019/05/07", "num": 6 }, { "date": "2019/05/08", "num": 25 }, { "date": "2019/05/09", "num": 24 }, { "date": "2019/05/10", "num": 38 }, { "date": "2019/05/11", "num": 19 }, { "date": "2019/05/12", "num": 43 }, { "date": "2019/05/13", "num": 23 }, { "date": "2019/05/14", "num": 70 }, { "date": "2019/05/15", "num": 185 }, { "date": "2019/05/16", "num": 119 }, { "date": "2019/05/17", "num": 120 }, { "date": "2019/05/18", "num": 77 }, { "date": "2019/05/19", "num": 85 }, { "date": "2019/05/20", "num": 45 }, { "date": "2019/05/21", "num": 72 }, { "date": "2019/05/22", "num": 70 }, { "date": "2019/05/23", "num": 62 }, { "date": "2019/05/24", "num": 86 }, { "date": "2019/05/25", "num": 89 }, { "date": "2019/05/26", "num": 56 }, { "date": "2019/05/27", "num": 25 }, { "date": "2019/05/28", "num": 53 }, { "date": "2019/05/29", "num": 77 }, { "date": "2019/05/30", "num": 103 }, { "date": "2019/05/31", "num": 35 }, { "date": "2019/06/01", "num": 98 }, { "date": "2019/06/02", "num": 71 }, { "date": "2019/06/03", "num": 61 }, { "date": "2019/06/04", "num": 100 }, { "date": "2019/06/05", "num": 153 }, { "date": "2019/06/06", "num": 92 }, { "date": "2019/06/07", "num": 78 }, { "date": "2019/06/08", "num": 48 }, { "date": "2019/06/09", "num": 74 }, { "date": "2019/06/10", "num": 64 }, { "date": "2019/06/11", "num": 74 }, { "date": "2019/06/12", "num": 165 }, { "date": "2019/06/13", "num": 314 }, { "date": "2019/06/14", "num": 143 }, { "date": "2019/06/15", "num": 213 }, { "date": "2019/06/16", "num": 1234 }, { "date": "2019/06/17", "num": 881 }, { "date": "2019/06/18", "num": 458 }, { "date": "2019/06/19", "num": 422 }, { "date": "2019/06/20", "num": 346 }, { "date": "2019/06/21", "num": 319 }, { "date": "2019/06/22", "num": 316 }, { "date": "2019/06/23", "num": 243 }, { "date": "2019/06/24", "num": 226 }, { "date": "2019/06/25", "num": 217 }], "channel": "app" }, { "data": [{ "date": "2019/05/07", "num": 1 }, { "date": "2019/05/13", "num": 2 }, { "date": "2019/05/16", "num": 5 }, { "date": "2019/05/17", "num": 2 }, { "date": "2019/05/24", "num": 1 }, { "date": "2019/06/12", "num": 1 }, { "date": "2019/06/15", "num": 2 }, { "date": "2019/06/17", "num": 44 }, { "date": "2019/06/18", "num": 4 }, { "date": "2019/06/21", "num": 1 }, { "date": "2019/06/22", "num": 3 }, { "date": "2019/06/23", "num": 1 }, { "date": "2019/06/25", "num": 2 }], "channel": "szb" }]

                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [barDataInit description] 柱形图数据格式化
             * @return {[type]} [description]
             */
            function barDataFormat() {
                let channelBarSeries = [];
                for (let i = 0; i < $scope.data.channelsData.length; i++) {
                    if ($scope.status.showChannel[$scope.data.channelsData[i].channel]) {
                        let seriesItem = {
                            name: $scope.status.channelList[$scope.data.channelsData[i].channel].name,
                            type: 'bar',
                            stack: '总量',
                            itemStyle: {
                                color: $scope.status.channelList[$scope.data.channelsData[i].channel].color
                            },
                            data: $scope.data.channelsData[i].data.map((dataItem) => {
                                return dataItem.num;
                            }),
                            barWidth: 16
                        }
                        channelBarSeries = i == 0 ? [].concat([seriesItem]) : channelBarSeries.concat([seriesItem]);
                    }
                }
                $scope.data.barOption.series = channelBarSeries;
            }
            /**
             * [initBarCanvas description] 柱状图初始化
             * @return {[type]} [description]
             */
            function initBarCanvas() {
                require(['echarts'], function(echarts) {
                    let barDom = document.getElementById("bar_canvas");
                    if (!barDom) {
                        return;
                    }
                    $scope.data.barChart = echarts.init(barDom);
                    let dateArr = $scope.data.channelsData[0].data.map((_item) => {
                        return $filter("date")(new Date(_item.date), "MMdd");
                    });
                    let seriesData = $scope.data.channelsData.map((seriesItem) => {
                        return {
                            name: $scope.status.channelList[seriesItem.channel].name,
                            type: 'bar',
                            stack: '总量',
                            itemStyle: {
                                color: $scope.status.channelList[seriesItem.channel].color
                            },
                            data: seriesItem.data.map((dataItem) => {
                                return dataItem.num;
                            }),
                            barWidth: 16
                        }
                    });
                    $scope.data.barOption = {
                        grid: {
                            top: '10',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            containLabel: true,
                            backgroundColor: '#EFEFEF',
                            show: true,
                            borderWidth: 0,
                        },
                        xAxis: {
                            type: 'category',
                            data: dateArr,
                            axisLabel: {
                                color: '#B4B4B4',
                                fontSize: 14,
                            },
                            splitLine: {
                                show: false
                            },
                            axisTick: {
                                show: false,
                                lineStyle: {
                                    color: ''
                                }
                            },
                            axisLine: {
                                show: false
                            }
                        },
                        yAxis: {
                            type: 'value',
                            axisLabel: {
                                color: '#B4B4B4',
                                fontSize: 14,
                                // padding: [0, 0, 0, 10],
                                // lineHeight: 20,
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#FFFFFF'
                                }
                            },
                            axisTick: {
                                show: false,
                                lineStyle: {
                                    color: ''
                                }
                            },
                            axisLine: {
                                show: false
                            },
                            max: function(value) {
                                return value.max + 100;
                            }
                        }
                    };
                    barDataFormat();
                    $scope.data.barChart.setOption($scope.data.barOption);
                });
            }
            /**
             * [getKeywordsData description] 获取关键词数据
             * @return {[type]} [description]
             */
            function getKeywordsData() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackKeywordCloud',
                    id: $scope.status.trackId,
                    dict_num: 30,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.keywordsData = data == '' ? [] : data;
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [initKeywordsCloud description] 关键词云图表初始化
             * @return {[type]} [description]
             */
            function initKeywordsCloud() {
                require(['echarts', 'echartsWordcloud'], function(echarts) {
                    let keywordDom = document.getElementById("keyword_chart");
                    if (!keywordDom) {
                        return;
                    }
                    $scope.data.keywordChart = echarts.init(keywordDom);
                    let wordCloudItems = $scope.data.keywordsData.map((_item) => {
                        return {
                            name: _item.name,
                            value: _item.num,
                        }
                    });
                    let option = {
                        title: {
                            text: "",
                        },
                        series: [{
                            type: 'wordCloud',
                            gridSize: 8,
                            sizeRange: [12, 40],
                            rotationRange: [-90, 90],
                            shape: 'ellipse',
                            width: '90%',
                            height: '80%',
                            rotationStep: 45,
                            textStyle: {
                                normal: {
                                    color: function(temp) {
                                        return 'rgb(' + [
                                            Math.round(Math.random() * 160),
                                            Math.round(Math.random() * 160),
                                            Math.round(Math.random() * 160)
                                        ].join(',') + ')';
                                    }
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    // shadowColor: '#333'
                                }
                            },
                            data: wordCloudItems,
                        }],
                    };
                    $scope.data.keywordChart.setOption(option);
                    $scope.data.keywordChart.on('click', function(param) {
                        // let url = $state.href('front.plan.realtimeclues.plannedclues.docdetail', {trackid:$scope.status.trackId,trackname:$scope.status.trackName,resoucetype:5,cloudwrod:param.name});
                        $state.go('front.plan.realtimeclues.plannedclues.docdetail', {
                            trackid: $scope.status.trackId,
                            trackname: $scope.status.trackName,
                            resoucetype: 5,
                            cloudword: param.name
                        });
                    });
                });
            }
            /**
             * [getKeywordsData description] 获取情感词数据
             * @return {[type]} [description]
             */
            function getEmotionWordsData() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackEmotion',
                    id: $scope.status.trackId,
                    dict_num: 30,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.emotionWordsData = data == '' ? [] : data;
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [initEmotionWordsCloud description] 情感词云图表初始化
             * @return {[type]} [description]
             */
            function initEmotionWordsCloud() {
                require(['echarts', 'echartsWordcloud'], function(echarts) {
                    let emotionDom = document.getElementById("emotion_chart");
                    if (!emotionDom) {
                        return;
                    }
                    $scope.data.emotionWordsChart = echarts.init(emotionDom);
                    let emotionCloudItems = $scope.data.emotionWordsData.map((_item) => {
                        return {
                            name: _item.name,
                            value: _item.num
                        }
                    });
                    let option = {
                        title: {
                            text: "",
                        },
                        series: [{
                            type: 'wordCloud',
                            gridSize: 8,
                            sizeRange: [12, 40],
                            rotationRange: [-90, 90],
                            shape: 'ellipse',
                            width: '90%',
                            height: '80%',
                            rotationStep: 45,
                            textStyle: {
                                normal: {
                                    color: function(temp) {
                                        return 'rgb(' + [
                                            Math.round(Math.random() * 160),
                                            Math.round(Math.random() * 160),
                                            Math.round(Math.random() * 160)
                                        ].join(',') + ')';
                                    }
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    // shadowColor: '#333'
                                }
                            },
                            data: emotionCloudItems,
                        }],
                    };
                    $scope.data.emotionWordsChart.setOption(option);
                    $scope.data.emotionWordsChart.on('click', function(param) {
                        $state.go('front.plan.realtimeclues.plannedclues.docdetail', {
                            trackid: $scope.status.trackId,
                            trackname: $scope.status.trackName,
                            resoucetype: 9,
                            cloudword: param.name
                        });
                    });
                });
            }
            /**
             * [getRelatedArticles description] 获取关联稿件数据
             * @return {[type]} [description]
             */
            function getRelatedArticles() {
                let defer = $q.defer();
                let params = {
                    serviceid: 'monitortrack',
                    modelid: 'trackDocs',
                    id: $scope.status.trackId,
                    page_no: 0,
                    page_size: 10
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.relatedArticles = data.PAGEITEMS;
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [getChannelsData description] 获取数据统计数据
             * @return {[type]} [description]
             */
            $scope.getChannelsData = function() {
                    getChannelsData().then(() => {
                        if ($scope.data.barChart) {
                            $scope.data.barChart.dispose();
                        }
                        initBarCanvas();
                    });
                }
                /**
                 * [dateFormat description] 时间显示格式转换
                 * @param  {[type]} dateStr [description] 时间字符串
                 * @return {[type]}         [description]
                 */
            $scope.dateFormat = function(dateStr) {
                    let date = new Date(dateStr);
                    return $filter("date")(date, "yyyy-MM-dd");
                }
                /**
                 * [toggleChannelData description] 动态改变柱状图数据
                 * @param  {[type]} channel [description] 渠道
                 * @return {[type]}         [description]
                 */
            $scope.toggleChannelData = function(channel) {
                    if (angular.isDefined(channel)) {
                        $scope.status.showChannel[channel] = !$scope.status.showChannel[channel];
                    }
                    barDataFormat();
                    $scope.data.barChart.setOption($scope.data.barOption, true);
                }
                /**
                 * [description] 销毁
                 * @param  {[type]} ) {                           if ($scope.data.keywordChart) {                    $scope.data.keywordChart.dispose();                }                if ($scope.data.mapChart) {                    $scope.data.mapChart.dispose();                }                if ($scope.data.barChart) {                    $scope.data.barChart.dispose();                }            } [description]
                 * @return {[type]}   [description]
                 */
            $scope.$on("$destroy", function() {
                if ($scope.data.keywordChart) {
                    $scope.data.keywordChart.dispose();
                }
                if ($scope.data.mapChart) {
                    $scope.data.mapChart.dispose();
                }
                if ($scope.data.barChart) {
                    $scope.data.barChart.dispose();
                }
            });
            /**
             * [slideTo description] 锚点跳转
             * @param  {[type]} nav [description] 导航
             * @return {[type]}     [description]
             */
            $scope.slideTo = function(nav) {
                if ($scope.status.checkClickFlag) {
                    $scope.status.checkClickFlag = false;
                    setTimeout(() => {
                        $scope.status.checkClickFlag = true;
                    }, 800)
                    if ($scope.status.selectedTab == nav || $scope.status.checkRollFlag == false) {
                        return;
                    }
                    let scrollTop = $('#' + nav.value).offset().top + $('.content_text_wrap').scrollTop() - 128;
                    $('.content_text_wrap').animate({ scrollTop: scrollTop + 'px' });
                    $scope.status.selectedTab = nav;
                }
            };

            /**
             * [linkFormat description] 稿件详情跳转
             * @param  {[type]} item [description] 稿件
             * @return {[type]}      [description]
             */
            $scope.linkFormat = function(item) {
                if (item.TYPE == "xhsg") {
                    return 'resourcexhsgbigdatadetail({guid:' + item.GUID + ',indexname:"' + item.INDEXNAME + '"})';
                }
                return 'resourcedetail({guid:' + item.GUID + ',indexname:"' + item.INDEXNAME + '"})';
            }
        }
    ]);